module.exports = __webpack_public_path__ + "img/VirtualCapabilities_00273.1f5a63e7.jpg";